import { sessionToken } from '../utils/session'

export async function readEvents(url, onEvent, signal) {
  const headers = { Accept: 'text/event-stream' }
  const token = sessionToken()
  if (token) headers.Authorization = `Bearer ${token}`
  const response = await fetch(url, { headers, signal })
  if (!response.ok) {
    let message = '进度连接失败'
    try {
      const data = await response.json()
      message = data.error || message
    } catch (e) {
      /* keep default */
    }
    const error = new Error(message)
    error.status = response.status
    throw error
  }
  const reader = response.body.getReader()
  const decoder = new TextDecoder()
  let buffer = ''
  let reading = true
  while (reading) {
    const { value, done } = await reader.read()
    if (done) {
      reading = false
      break
    }
    buffer += decoder.decode(value, { stream: true })
    const chunks = buffer.split('\n\n')
    buffer = chunks.pop() || ''
    chunks.forEach((chunk) => {
      const line = chunk.split('\n').find((item) => item.startsWith('data:'))
      if (!line) return
      onEvent(JSON.parse(line.slice(5).trim()))
    })
  }
}
